import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cnpjMask'
})
export class CnpjMaskPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      value = value.replace(/\D/g, '');
      if(value.length === 14) {
        value = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
      }
      return value;
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/cnpj-mask.pipe.ts
 **/